import PaymentMethod from "./PaymentMethod";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import i18n from "../../i18n";

// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!,
  {
    locale: i18n.language as "ar" | "en",
  }
);
type PaymentCardProps = {
  clientSecret: string;
  redirectTo: string;
};
export default function PaymentCard(props: PaymentCardProps) {
  const { clientSecret, redirectTo } = props;
  const options = {
    //  the client secret obtained from the server
    clientSecret,
  };

  return (
    <div className="w-full bg-white mb-2 shadow h-fit overflowY-auto rounded-md p-6">
      <Elements stripe={stripePromise} options={options}>
        <PaymentMethod redirectTo={redirectTo} />
      </Elements>
    </div>
  );
}
